<template>
  <div class="head-top">
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-menu-item index="1">
        <div class="logo-bg">
          <a href="/main">
            <img
              src="../../assets/rj-int-logo.png"
              alt="err"
            ></a>
        </div>
      </el-menu-item>
      <el-menu-item index="3" style="border-bottom:solid 1px #e6e6e6;">
        <div v-if="flag" class="search-operate">
          <el-radio-group size="small" v-model="serchStatus">
            <el-radio-button label="1">
              {{ $t('homePage.quotation') }}
            </el-radio-button>
            <el-radio-button label="2">
              {{ $t('homePage.product') }}
            </el-radio-button>
          </el-radio-group>
          <el-autocomplete
            size="small"
            v-if="serchStatus==='1'"
            v-model="state3"
            :fetch-suggestions="querySearch"
            :placeholder="$t('homePage.quotationSearch')"
            @keyup.enter.native="handleIconClick"
          >
            <i
              class="el-icon-search el-input__icon"
              slot="suffix"
              @click="handleIconClick"
            />
            <template slot-scope="{ item }">
              <div class="name">{{ item.value }}</div>
              <span class="addr">{{ item.address }}</span>
            </template>
          </el-autocomplete>
          <el-autocomplete
            size="small"
            v-if="serchStatus==='2'"
            v-model="state4"
            :fetch-suggestions="querySearch"
            :placeholder="$t('homePage.searchProductModel')"
            @keyup.enter.native="productClick"
          >
            <i
              class="el-icon-search el-input__icon"
              slot="suffix"
              @click="productClick"
            />
            <template slot-scope="{ item }">
              <div class="name">{{ item.value }}</div>
              <span class="addr">{{ item.address }}</span>
            </template>
          </el-autocomplete>
        </div>
      </el-menu-item>
      <el-submenu index="6" style="float: right">
        <template slot="title">
          {{ $t('homePage.productChangeThat') }}
        </template>
        <el-menu-item index="6-3">
          {{ $t('homePage.supplyBusinessSupport') }} : liuxiaotong
        </el-menu-item>
      </el-submenu>
      <el-submenu index="2" style="float: right">
        <template slot="title">
          {{ username }}
        </template>
        <el-menu-item index="2-3" @click="showVideoUserGuid">
          {{ $t('homePage.videoDirection') }}
        </el-menu-item>
        <el-menu-item index="2-5">
          <router-link to="/Settings/index">
            {{ $t('homePage.personalSetting') }}
          </router-link>
        </el-menu-item>
        <el-menu-item index="2-8" v-if="adminRole" @click="userAuth">
          {{ $t('homePage.userAuthorization') }}
        </el-menu-item>
        <el-menu-item index="2-9" @click="exitSystem">
          {{ $t('homePage.logOut') }}
        </el-menu-item>
      </el-submenu>
      <el-menu-item index="7" style="float: right" @click="myOpinion">
        {{ $t('homePage.wantScore') }}
      </el-menu-item>
      <!--产品变更说明-->
      <el-menu-item
        index="10"
        style="float:
        right" @click="ruleFeedback"
      >
        {{ $t('homePage.ruleWrongWantFeedback') }}
      </el-menu-item>
      <!-- TODO 语言切换， 上线需删除 -->
      <!--<el-menu-item index="10" style="float: right">-->
      <!--  <el-select-->
      <!--    v-model="languageKey"-->
      <!--    style="width: 80px;"-->
      <!--    @change="changeLanguageKey"-->
      <!--  >-->
      <!--    <el-option label="中文" value="zh" />-->
      <!--    <el-option label="英文" value="en" />-->
      <!--  </el-select>-->
      <!--</el-menu-item>-->
    </el-menu>

    <!--我有意见-->
    <el-dialog
      :title="$t('homePage.yourAdvice')"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="true"
      append-to-body
      :show-close="true"
    >
      <el-form
        :model="isMyOpinion"
        :rules="rules"
        ref="isMyOpinion"
        @submit.native.prevent
        @keyup.enter.native="submitOpinion('isMyOpinion')"
      >
        <el-form-item
          :label="$t('homePage.newAccurate')"
          prop="grade"
        >
          <div class="block">
            <el-rate
              v-model="isMyOpinion.validateGrade"
              :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
              show-text
            />
          </div>
        </el-form-item>
        <el-form-item :label="$t('homePage.configuratorOverall')" prop="grade">
          <div class="block">
            <el-rate
              v-model="isMyOpinion.grade"
              :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
              show-text
            />
          </div>
        </el-form-item>

        <el-form-item
          :label="$t('homePage.otherSuggestions')"
          prop="opinion"
        >
          <el-input
            style="height: 150px"
            v-model.trim="isMyOpinion.opinion"
            type="textarea"
            maxlength="200"
            :autosize="{ minRows: 2, maxRows: 6}"
            :placeholder="$t('homePage.pleaseEnterComments')"
            @input="descInput"
          />
          <span class="numberV">{{ txtVal }}/200</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="setVersionUpdating()"
        >
          {{ $t('homePage.takeAway') }}
        </el-button>
        <el-button
          type="primary"
          @click="submitOpinion('isMyOpinion')"
        >
          {{ $t('homePage.confirm') }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 规则有误,我要反馈-->
    <el-dialog
      width="500px"
      append-to-body
      :title="$t('homePage.ruleWrongWantFeedback')"
      :visible.sync="ruleFeedbackDialogForm"
      @close="ruleFeedbackInfo = ''"
    >
      <el-form
        ref="formFeedback"
        @submit.native.prevent
        @keyup.enter.native="ruleFeedbackSubmit"
      >
        <el-form-item prop="opinion">
          <el-input
            v-model.trim="ruleFeedbackInfo"
            type="textarea"
            maxlength="200"
            :autosize="{ minRows: 5, maxRows: 20 }"
            :placeholder="$t('homePage.pleaseEnterContent')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ruleFeedbackDialogForm = false">
          {{ $t("homePage.takeAway") }}
        </el-button>
        <el-button type="primary" @click="ruleFeedbackSubmit">
          {{ $t("homePage.confirm") }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { setStore, getStore, isPartnerM, removeStore } from "@/utils/mUtils";
import API from "@/api";
import Cookies from "js-cookie";
import eventBus from "../../utils/eventBus";
import { removeAllCookie } from "../../utils/loginOut";
export default {
  // props:['lang'],
  data() {
    return {
      serchStatus: "1", // 首页 头部搜索框
      username: getStore("username"), // 登录用户名
      activeIndex: `1`,
      displayTask: false,
      displayLaw: false,
      restaurants: [],
      state3: "", // 首页头部搜索框 price list 的值
      state4: "", // 首页头部搜索框 product 的值
      dialogVisible: false,
      dialogFormVisible: false,
      ruleFeedbackDialogForm: false,
      ruleFeedbackInfo: null,
      isMyOpinion: {
        validateGrade: 0,
        grade: 0,
        opinion: "",
      },
      // 表单验证
      rules: {
        // validateGrade: [{required: true, message: '请为校验功能打分，十分感谢', trigger: 'blur'}],
        // grade: [{required: true, message: '请为使用体验打分，十分感谢', trigger: 'blur'}],
        // opinion: [
        //   {required: true, message: '请输入您的意见', trigger: 'blur' },
        //   {max: 200, message: '长度不得超过200个字符', trigger: 'blur'}]
      },
      txtVal: 0,
      adminRole: false,
      cities: [
        {
          value: "Beijing",
          label: "北京",
        },
        {
          value: "Shanghai",
          label: "上海",
        },
        {
          value: "Nanjing",
          label: "南京",
        },
        {
          value: "Chengdu",
          label: "成都",
        },
        {
          value: "Shenzhen",
          label: "深圳",
        },
        {
          value: "Guangzhou",
          label: "广州",
        },
      ],
      languageKey: window.localStorage.getItem("language"),
    };
  },
  computed: {
    ...mapState(["adminInfo"]),
    flag() {
      return this.$route.path.startsWith("/main");
    },
  },
  methods: {
    changeLanguageKey(value) {
      window.localStorage.setItem("language", value);
      window.location.reload();
    },
    isPartnerM,
    ...mapActions(["getAdminData"]),
    getCurrentLoginedUser() {
      API.getUserInfo()
        .then((result) => {
          if (result !== undefined) {
            let json = result.data;
            if (json.status === "200") {
              if (json.data.role === "999") {
                this.adminRole = true;
              }
              setStore(`userId`, json.data.userId);
              setStore(`username`, json.data.userName);
              setStore(`partnerFlg`, json.data.partnerFlg);
              setStore(`industryFlg`, json.data.industryFlg);
              setStore(`partnerAuth`, json.data.partnerAuth);
              setStore(`searchMode`, json.data.searchMode);
              setStore(`channelCountries`, json.data.authRegions);
              this.username = json.data.userName;
              let storage = window.localStorage;
              if (json.data.deptName != null) {
                storage.setItem("deptName", json.data.deptName);
              } else {
                storage.setItem("deptName", json.data.userType);
              }

              if (json.data.guideInfo.feedbackSwitch) {
                this.myOpinion();
              }

              eventBus.$emit("postUserGuide", json.data);
              eventBus.$emit("getVersionUpdating", json.data);
            }
          }
        })
        .catch((e) => {
          console.error("error", e);
        });
    },
    querySearch(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    handleSelect(item) {
      // console.log("11111==="+item);
    },
    handleIconClick(ev) {
      // 出发列表页查询
      eventBus.$emit("searchByKeyWords", this.state3, false);
    },
    productClick(ev) {
      // 出发列表页查询
      eventBus.$emit("searchByKeyWords", this.state4, true);
    },
    // 视频引导
    showVideoUserGuid() {
      eventBus.$emit("postVideoUserGuide");
    },
    // 退出
    exitSystem() {
      this.$confirm(
        `${this.$t("homePage.whetherOut")}`,
        `${this.$t("homePage.prompt")}`,
        {
          confirmButtonText: `${this.$t("homePage.confirm")}`,
          cancelButtonText: `${this.$t("homePage.takeAway")}`,
          type: "warning",
        }
      )
        .then(() => {
          document.cookie =
            "phplogin=; max-age=0; domain=.ruijie.com.cn;path=/";
          document.cookie =
            "PartnerUser=; max-age=0; domain=.ruijie.com.cn;path=/";
          document.cookie =
            "ruijieportal=; max-age=0; domain=.ruijie.com.cn;path=/";
          Cookies.set("phpLogin_prod", "");
          Cookies.set("phplogin", "");
          Cookies.set("PartnerUser", "");
          Cookies.set("ruijieportal", "");
          Cookies.set("ruijieportal_prod", "");
          Cookies.set("user_id", "");
          Cookies.set("uid", "");
          Cookies.set("PartnerUser_prod", "");
          Cookies.remove("phpLogin_prod");
          Cookies.remove("phplogin");
          Cookies.remove("PartnerUser");
          Cookies.remove("ruijieportal");
          Cookies.remove("ruijieportal_prod");
          Cookies.remove("user_id");
          Cookies.remove("uid");
          Cookies.remove("PartnerUser_prod");
          removeAllCookie();
          // 退出系统跳转登录页
          let backURL = window.location.href;
          let port = "";
          if (window.location.port) {
            port = `:${window.location.port}`;
          }
          let domain = "";
          let api = "";
          let adapter = "";
          if (backURL.indexOf("wpc") !== -1) {
            api = "/api";
          }
          let redirect = backURL;
          redirect = encodeURIComponent(redirect);
          if (
            backURL.indexOf("wpcpartnertest") !== -1 ||
            backURL.indexOf("wpcuat") !== -1
          ) {
            // domain = `http://partners.ruijie.com.cn/LayerPartnerLogin.aspx?URL=`;
            // adapter = `${domain}${window.location.protocol}//${window.location.host}${api}/product/adapter?redirectUrl=${redirect}`;
            // window.location.href = `https://www.ruijienetworks.com/login.aspx?r=${window.location.href}`;
            
            if(window._env_.NODE_ENV === "pro") {
window.location.href = `https://account.ruijie.com?r=${encodeURIComponent(
              window.location.href
            )}`;
            } else {
window.location.href = `https://account-uat.ruijie.com?r=${encodeURIComponent(
              window.location.href
            )}`;
            }
          } else {
            // domain = `https://sid.ruijie.com.cn/logout?service=http%3A%2F%2Fsso.ruijie.com.cn%2Flogin.php%3FURL%3Dhttp%253A%252F%252F`;
            // adapter = `${domain}${window.location.host}`;
            // window.location.href = `https://www.ruijienetworks.com/login.aspx?r=${window.location.href}`;
           if(window._env_.NODE_ENV === "pro") {
window.location.href = `https://account.ruijie.com?r=${encodeURIComponent(
               window.location.href
            )}`;
           } else {
window.location.href = `https://account-uat.ruijie.com?r=${encodeURIComponent(
               window.location.href
            )}`;
           }
            
          }
          // window.location.href = adapter;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("homePage.cancelOut")}`,
          });
        });
    },
    myOpinion() {
      this.dialogFormVisible = true;
    },
    ruleFeedback() {
      this.ruleFeedbackDialogForm = true;
    },
    // 提交意见
    submitOpinion(formName) {
      if (this.isMyOpinion.validateGrade === 0) {
        this.$alert("请为校验功能评分，谢谢您的支持");
        return;
      }
      if (this.isMyOpinion.grade === 0) {
        this.$alert("请为整体使用体验评分，谢谢您的支持");
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          API.addUserFeedback(this.isMyOpinion)
            .then((res) => {
              let json = res.data;
              if (json.status === 204) {
                this.$notify.success("感谢您的反馈");
                this.$refs[formName].resetFields();
                this.dialogFormVisible = false;
              } else {
                this.$notify.success(json.err);
              }
            })
            .catch((err) => {
              this.$notify.info(err);
            });
          this.dialogFormVisible = false;
        } else {
          return false;
        }
      });
    },
    ruleFeedbackSubmit() {
      let ruleFeedbackInfo = this.ruleFeedbackInfo;
      if (ruleFeedbackInfo != null && ruleFeedbackInfo.length > 0) {
        let param = {
          opinion: ruleFeedbackInfo,
        };
        param.type = 2;
        API.addUserFeedback(param)
          .then((res) => {
            let json = res.data;
            if (json.status === "204") {
              this.$notify.success(json.err);
              this.ruleFeedbackInfo = null;
              this.ruleFeedbackDialogForm = false;
            } else {
              this.$notify.error(json.err);
            }
          })
          .catch(() => {
            this.$notify.info("网络异常！");
          });
      } else {
        this.$alert("反馈内容不能为空");
      }
    },
    setVersionUpdating() {
      API.setVersionSwitch()
        .then((res) => {
          if (res.data.status === 200) {
            // this.versionUpdating=false;
            // this.versionUpdating=true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 可输入长度
    descInput() {
      this.txtVal = this.isMyOpinion.opinion.length;
    },
    // 用户授权
    userAuth() {
      this.$router.push({ path: "/auth" });
    },
  },
  mounted() {
    this.getCurrentLoginedUser();
  },
};
</script>

<style lang="scss">
@import "../../styles/mixin";
.head-top .el-dialog__footer .dialog-footer {
  text-align: right;
}
.el-dialog__header .el-dialog__title {
  font-size: 18px;
}
.head-top .el-dialog__body {
  padding-top: 0;
  padding-bottom: 0;
}
.head-top {
  .el-form-item--small {
    margin: 20px 0px 0px 0px;
  }
}
.el-button--primary {
  background: #36bade !important;
  border: 1px solid #36bade !important;
}

.el-button--default:hover {
  background: rgba(54, 186, 222, 0.2) !important;
  border: 1px solid #36bae2 !important;
}

.el-menu-demo {
  box-sizing: border-box;
}

.el-menu-demo .el-menu-item:nth-of-type(1) {
  margin: 0;
  padding: 0;
  width: 24rem;
}

.logo-bg {
  width: 100%;
  padding-left: 2rem;
}
.logo-bg img {
  width: 15rem;
}

.head-top .el-menu {
  height: 60px;
}

.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 70px;
}


.el-menu-demo .el-menu-item:nth-of-type(3) {
  color: #606266;
  font-size: 1.4rem;
  float: right;
  padding-right: 12px;
}

.el-menu-demo .el-menu-item:nth-of-type(3):hover {
  color: #36bade;
}

.el-menu-demo .el-menu-item:nth-of-type(4) {
  color: #303133;
  font-size: 1.4rem;
  float: right;
}

.el-menu-demo .el-menu-item:nth-of-type(4):hover .el-dropdown-link {
  color: #36bade;
}

.el-menu-demo .el-menu-item:nth-of-type(4):hover .el-dropdown-link i {
  color: #36bade;
}
.el-menu-demo .el-menu-item:last-of-type:hover {
  border-bottom: 1px solid #36bade !important;
  color: #36bade !important;
}

.el-menu-demo .el-submenu:hover {
  border-bottom: 1px solid #36bade !important;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: solid 1px #e6e6e6;
  color: #909399 !important;
}

.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: 0;
  color: #303133;
}

.el-menu--horizontal > .el-menu-item:hover {
  border-bottom: solid 1px #e6e6e6;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: solid 1px #e6e6e6;
  color: #333333;
}
.search-operate {
  .el-input__inner {
    // 搜索背景
    background-color: #fafafa;
  }
  .el-icon-search {
    // 搜索icon
    vertical-align: middle;
    //top: 3px !important;
  }
}
.el-icon-search-product {
  .el-input__inner {
    // 搜索背景
    background-color: red !important;
  }
  //background-color: #FAFAFA;
}
.my-autocomplete {
  li {
    line-height: normal;
    padding: 0.7rem;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .addr {
      font-size: 1.2rem;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
//技术支持
.head-top .el-dropdown {
  font-size: 1.4rem;
  line-height: 50px;
  margin-right: 10px;
  height: 100%;
  color: #a8a297;
}

.head-top .el-dropdown:hover {
  color: #36bade !important;
}

.head-top .el-submenu__title:hover {
  color: #36bae2 !important;
}

.head-top .el-dropdown i {
  line-height: 1.6rem;
  width: 28px;
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: rgb(54, 186, 222);
  background: rgba(54, 186, 222, 0.2);
}

.head-top .el-autocomplete .el-input__inner {
  width: 30rem;
  height: 3.2rem;
  line-height: 3.2rem;
  margin-bottom: 0.5rem;
}

.el-autocomplete .el-input__inner:focus {
  border: 1px solid #36bade;
}

.el-autocomplete .el-input__suffix {
  height: 3.2rem;
  line-height: 3.2rem;
}

table th .cell {
  color: #333333;
}

.btn-p .el-button--default {
  width: 20rem;
  height: 3.6rem;
  line-height: 0;
}

.btn-p .el-button--primary {
  width: 20rem;
  margin-left: 4rem;
  height: 3.6rem;
  line-height: 0;
}

.head-top .el-icon-search {
  position: absolute;
  top: 13px;
  right: 0;
}

.head-top .numberV {
  position: absolute;
  right: 6px;
  bottom: -6px;
  font-size: 12px;
}
.head-top .el-dialog .el-form-item__label {
  text-align: left;
  //word-break: break-all;
  word-wrap: break-word;
}
.head-top .el-dialog .el-dialog__header {
  text-align: left;
  font-size: 1.6rem;
  height: 5rem;
  line-height: 2.8rem;
  border-bottom: 1px solid #ebebeb;
  padding: 16px 20px 10px;
}

.head-top .el-dialog {
  width: 40%;
}

.head-top .block {
  margin-top: 65px;
  margin-left: 0px;
  .el-icon-star-off:before {
    font-size: 25px;
  }
}
.el-message-box__title {
  font-size: 18px !important;
}
.el-message-box__wrapper {
  top: -30% !important;
}
.el-message-box__status {
  font-size: 20px !important;
}
.head-top .dialog-footer {
  text-align: center;
}
.el-autocomplete {
  margin-left: 10px;
}
.head-top .el-textarea__inner {
  height: 150px !important;
}
</style>
